import { handleAuthToken } from "@pathwright/web-new/src/lib/utils/auth-token"
import { useEffect } from "react"
import { StringParam, useQueryParam } from "use-query-params"
import { useGetTokenViaSsoMutation } from "../api/generated"

// Hook for handling the ?sso query param in local development
// for authentication super users. The backend handles the ?sso
// query param already, but we need this for local dev.
function useLocalDevSSO() {
  const [ssoToken, setSSOQueryParam] = useQueryParam("sso", StringParam)
  const [getTokenViaSso] = useGetTokenViaSsoMutation({
    // Once completed, handle the auth token (by signing in the user) and remove the query param.
    onCompleted(data) {
      const token = data.getTokenViaSSO?.token
      if (token) {
        handleAuthToken(token)
      } else {
        console.error(
          "Failed to retrieve auth token via SSO token in query params. Removing."
        )
      }
      // Always remove the sso query param after using it.
      setSSOQueryParam(undefined, "replaceIn")
    }
  })

  useEffect(() => {
    if (ssoToken && process.env.NODE_ENV === "development") {
      getTokenViaSso({ variables: { ssoToken } })
    }
  }, [ssoToken])
}

export default useLocalDevSSO
